const FOOTER_LINKS = [
  { label: "本期排行榜", href: "#ranking" },
  { label: "豆瓣高分精选", href: "#douban" },
  { label: "类型片浏览器", href: "#genre" },
  { label: "动作片专区", href: "#action" },
  { label: "爱情片专区", href: "#romance" },
  { label: "恐怖片专区", href: "#horror" },
  { label: "评分口径说明", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">九七电影院</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              一个把排行榜、口碑高分与类型片线索收在同一页的找片参考站，帮你在几分钟内圈出今晚想看的那部。
            </p>
            <a
              href="#top"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50/10 px-4 py-2 text-sm transition-colors hover:bg-background-50/20"
            >
              <i className="ri-arrow-up-line" />
              回到页面顶部
            </a>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-3 sm:grid-cols-3 lg:grid-cols-4">
            {FOOTER_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="whitespace-nowrap text-sm text-background-200 transition-colors hover:text-accent-300"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>本页为找片参考展示，评分与榜单为站内综合整理，仅供浏览时对照使用。</p>
          <p>© {new Date().getFullYear()} 九七电影院</p>
        </div>
      </div>
    </footer>
  );
}